import classNames from 'classnames';
import * as React from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import Collapse from 'src/view/components/Collapse/Collapse';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

export interface IcollapsibleProps {
  /**
   * Label of Header
   *
   * @type {string}
   * @memberof IcollapsibleProps
   */
  label: string;
  /**
   * Component that is displayed on the right side
   * If you do not pass this parameter, the chevron will be at the far right
   *
   * @type {*}
   * @memberof IcollapsibleProps
   */
  headerRight?: React.ReactNode;
  /**
   * Component that is hidden
   * If you do not pass this parameter, the chevron will not show
   *
   * @type {*}
   * @memberof IcollapsibleProps
   */
  collpsedContent?: any;
  className?: string;
}

/**
 * Collapsible Component
 *
 * If you not pass chidren component, chevron will not render and header will not pointer
 *
 * If you not pass rightComponent chevron will be displayed on the left
 *
 * @param label - Text displayed on the left
 * @param rightComponent - Component displayed on the right
 * @param className - ClassName to append to the class name of the collapsible component.
 */
export const Collapsible = ({ label, className, headerRight, collpsedContent }: IcollapsibleProps) => {
  const [isOpened, setOpened] = React.useState(false);

  const onClickHeader = React.useCallback(() => {
    setOpened(!isOpened);
  }, [isOpened]);

  return (
    <div className={classNames('collapsible', className, { open: isOpened })}>
      <div className={`collapsible-header ${collpsedContent ? 'cursor-pointer' : ''}`} onClick={onClickHeader}>
        {/* Header */}
        <div className="d-flex flex-row align-items-center justify-content-between">
          {/* Label */}
          <p className="text-size-16">{label}</p>
          {/* Chevron */}
          {collpsedContent ? <Icon name={Icons.Chevron} className="collapsible-chevron" /> : null}
        </div>
        {/* Right componentt */}
        {headerRight ? <div className="collapsible-right">{headerRight}</div> : null}
      </div>
      {/* Collapsed */}
      {collpsedContent ? (
        <Collapse className="collapsible-collapse" isOpened={isOpened}>
          <div className="d-flex flex-row justify-content-between full-width">{collpsedContent}</div>
        </Collapse>
      ) : null}
    </div>
  );
};
